import { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useUserSession from '@medflex/hooks/useUserSession';

const threeMinutes = 1000 * 3 * 60;

const useOnlineStatus = userId => {
  const onlineStatus = useSelector(state => state.onlineStatus);
  const { session } = useUserSession();
  const [isPullingInitiated, setIsPullingInitiated] = useState(false);
  const dispatch = useDispatch();
  const loadOnlineStatus = () => dispatch.onlineStatus.load();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isPullingInitiated && session && !session.expired) {
      // @todo: activate once onlineStatus has own endpoint. Commenting prevents double GET /contacts request on page load
      // loadOnlineStatus();
      const interval = setInterval(loadOnlineStatus, threeMinutes);
      return () => {
        clearInterval(interval);
      };
    }
  }, [isPullingInitiated, session]);

  const isOnline = useMemo(() => {
    if (userId) {
      const { isOnline = false } = onlineStatus.find(s => s.userId === userId && s.isOnline) || {};
      return isOnline;
    }

    return false;
  }, [userId, onlineStatus]);

  const onlineUserIds = useMemo(
    () => onlineStatus.filter(c => c.isOnline).map(c => c.userId),
    [onlineStatus],
  );

  return { initiatePulling: () => setIsPullingInitiated(true), onlineUserIds, isOnline };
};

export default useOnlineStatus;
